import { ILog } from './../types';
import { ICommand } from 'core-ts-types';
angular
  .module('capability-ng-global')
  .config(function(NetworkFaultConfigurationProvider: any) {
    NetworkFaultConfigurationProvider.activate();
  })
  .config(function($httpProvider: ng.IHttpProvider, log: ILog) {
    const reloadPageLinkHTML = `<p><button x-ph3 onclick="location.reload(true)" onkeypress="if (event.which === 13) location.reload(true)" class="type-link">Refresh the page</button></p>`;

    const issues = {
      '-1': () => {
        return {
          title: 'Connection Failure',
          content: `Looks like you've lost internet connection.  Reconnect and try again.`
        };
      },
      '400': () => {
        return {
          title: 'Request Failure',
          content: 'There was a problem with your request'
        };
      },
      '401': () => {
        return {
          title: 'Request Failure',
          content: 'You are not logged in'
        };
      },
      '403': () => {
        return {
          title: 'Request Failure',
          content: 'You do not have permission to view this content'
        };
      },
      '404': () => {
        return {
          title: 'Request Failure',
          content: `The resource you have requested was not found`
        };
      },
      '500': () => {
        return {
          title: 'Request Failure',
          content: `The server was unable to process your request ${reloadPageLinkHTML}`
        };
      },
      '503': () => {
        return {
          title: 'Request Failure',
          content: `The service is unavailable at the moment. Please try again later`
        };
      }
    };

    $httpProvider.interceptors.push(function($q) {
      return {
        response: function(response: any) {
          if (!_.isEmpty(response.data.errors)) {
            _.each(response.data.messages, (message, messageTopic) => {
              log.user.error({
                title: `Issue on: ${messageTopic}`,
                content: message,
                dismissOnTimeout: false,
                dismissButton: true
              });
            });
          }

          return response;
        },
        responseError: function(rejection) {
          if (!rejection) {
            return $q.defer();
          }

          if (!_.isFunction(issues[rejection.status])) {
            return $q.reject(rejection);
          }

          if (!!rejection.data && !_.isEmpty(rejection.data.error.errors)) {
            return $q.reject(rejection);
          }

          const error = issues[rejection.status](rejection);

          log.user.error(error);

          return $q.reject(rejection);
        }
      };
    });
  })
  .run(function(
    NetworkFaultConfiguration: any,
    resetLocalAccountCommand: ICommand,
    $state: ng.ui.IStateService,
    log: ILog
  ) {
    NetworkFaultConfiguration.onResponseFailure('401', function() {
      resetLocalAccountCommand().then(() => {
        $state.go('landing', {
          explanation: 'You are not logged into the server'
        });
      });
    });

    NetworkFaultConfiguration.onResponseFailure('403', function() {
      resetLocalAccountCommand().then(() => {
        $state.go('landing', {
          explanation: 'You are not logged into the server'
        });
      });
    });
  });



// WEBPACK FOOTER //
// ./app/lib/global/configuration/network_failure.ts